// extracted by mini-css-extract-plugin
export default {"selectMenu":"CustomSelect_selectMenu__-qsyX","selectContainer":"CustomSelect_selectContainer__rcwO3"};